import React from 'react'
import "./hospital.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function Hospital() {

   return (
      <>
         <div className="container">
            <CustomTitle title="المستشفيات" />
            <h2 className='main-header mt-5 pt-5'>Hospital Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
